module.exports = __webpack_public_path__ + "static/media/lightbulb_2.3ce26934.png";